import React, { useState, useEffect } from "react";
import { LoadScript, Autocomplete } from "@react-google-maps/api";
import './LocationSearch.css';

const libraries = ["places"]; // Declare libraries array as a constant outside the component

const LocationSearch = ({ onLocationSelect, defaultValue }) => {
  const [autocomplete, setAutocomplete] = useState(null);
  const [inputValue, setInputValue] = useState(defaultValue || ""); // Initialize input with defaultValue

  useEffect(() => {
    setInputValue(defaultValue || ""); // Update when defaultValue changes
  }, [defaultValue]);

  const handleLoad = (autoC) => {
    setAutocomplete(autoC);
  };

  const handlePlaceChanged = () => {
    if (autocomplete !== null) {
        const place = autocomplete.getPlace();
        if (place && place.geometry) {
            let fullAddress = place.formatted_address || place.name; // Use full address
            let components = place.address_components; // Get detailed address components

            // Extract hall name (establishment) if available
            let hallName = components?.find(c => c.types.includes("establishment"))?.long_name || "";

            if (hallName) {
                fullAddress = hallName + ", " + fullAddress; // Prepend hall name
            }

            const location = {
                name: fullAddress,
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng(),
            };

            setInputValue(fullAddress); // Update input field with full address
            onLocationSelect(location);
        }
    }
};


  return (
    <LoadScript
      googleMapsApiKey="AIzaSyDLQyAYxjoHc8NUC3a2cbjh2Uhj5DfUUQc" // Replace with your actual API key
      libraries={libraries} // Use the constant libraries array
    >
      <Autocomplete onLoad={handleLoad} onPlaceChanged={handlePlaceChanged}>
        <input
          type="text"
          placeholder="חפש מקום..."
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)} // Allow manual input
        />
      </Autocomplete>
    </LoadScript>
  );
};

export default LocationSearch;
